module.exports = "https://coursera_assets.s3.amazonaws.com/images/ca0792e2e00e2dc6802432510856daf8.png";